const CURRENCY_SYMBOLS = {
  EUR:'€', USD:'$', MGA:'Ar', XOF:'CFA',
  GBP:'£', ZAR:'R', CHF:'CHF', CAD:'CA$',
};

export function getCurrencySymbol(code) {
  return CURRENCY_SYMBOLS[code] || code || '$';
}

export function formatAmount(n, currencyCode) {
  const symbol = getCurrencySymbol(currencyCode);
  const formatted = new Intl.NumberFormat('fr-FR').format(Math.round(n || 0));
  // Symboles apres le montant: Ar, CFA, CHF, R
  const after = ['Ar','CFA','CHF','R','CA$'];
  if (after.includes(symbol)) return formatted + ' ' + symbol;
  return symbol + ' ' + formatted;
}